class Socket {
    #announced = false;
    #conn = null;
    #sendQueue = [];
    #callbacks = [];

    /**
     * @param {object} data
     * @param {function} cb
     */
    announce(data, cb) {
        this._registerCallback('announce_success', (data) => {
            this.#announced = true;
            cb(data !== null && typeof data.sessionId !== 'undefined' ? data.sessionId : null);
        }, true);

        this._send('announce', data);
    }

    resume(data, cb) {
        this._registerCallback('resume_answer', (data) => {
            if (typeof data.status !== 'undefined' && data.status === 200) {
                this.#announced = true;
                cb(true, data.history ?? []);
            } else {
                cb(false)
            }
        }, true);

        this._send('resume', data);
    }

    /**
     * @param {string} message
     */
    sendMessage(message) {
        if (!this.#announced) {
            throw new Error('Socket has not yet announced itself')
        }

        this._send('message', message);
    }

    /**
     * @param {string} type
     * @param {function} cb
     */
    on(type, cb) {
        this._registerCallback(type, cb, false);
    }

    /**
     * @param {string} type
     * @param {function} cb
     */
    off(type, cb) {
        this._unregisterCallback(type, cb);
    }

    /**
     * @param {string} type
     * @param {function} cb
     * @param {boolean} once
     *
     * @return {number}
     *
     * @private
     */
    _registerCallback(type, cb, once) {
        console.log("[socket] _registerCallback: " + type + " (once: " + once + ")");

        if (typeof once === 'undefined') {
            once = true;
        }

        this.#callbacks.push({
            type: type,
            cb: cb,
            once: once
        });
    }

    /**
     * @param {string} type
     * @param {function} cb
     *
     * @private
     */
    _unregisterCallback(type, cb) {
        console.log("[socket] _unregisterCallback: " + type);

        for (let i = 0; i < this.#callbacks.length; i++) {
            if (this.#callbacks[i].type === type && this.#callbacks[i].cb === cb) {
                this.#callbacks.splice(i, 1);
            }
        }
    }

    /**
     * @param {string} type
     * @param {*} data
     *
     * @private
     */
    _send(type, data) {
        console.log("[socket] _send: " + type);

        const payload = JSON.stringify({
            type: type,
            data: data
        })

        if (this.#conn === null) {
            // No ws connection was created yet. Push data into queue & create conn
            this.#sendQueue.push(payload);
            this.#conn = new WebSocket("wss://" + location.host);

            this.#conn.onopen = () => {
                for (let i = 0; i < this.#sendQueue.length; i++) {
                    this.#conn.send(this.#sendQueue[i]);
                }

                this.#sendQueue = [];
            };

            this.#conn.onmessage = (event) => {
                const data = JSON.parse(event.data);

                if (typeof data.type === 'undefined') {
                    return;
                }

                for (let i = 0; i < this.#callbacks.length; i++) {
                    if (this.#callbacks[i].type === data.type) {
                        this.#callbacks[i].cb(
                            typeof data.data === 'undefined' ? null : data.data
                        )

                        if (this.#callbacks[i].once) {
                            this.#callbacks.splice(i, 1);
                        }
                    }
                }
            };

            this.#conn.onclose = (event) => {
                this.#conn = null;

                // is there other stuff to do here?
            };

        } else if (this.#conn.readyState === 1) {
            // connection was created and is ready. Send data directly

            this.#conn.send(payload);
        } else {
            // connection was created but is not yet ready. Push data into queue

            this.#sendQueue.push(payload);
        }
    }
}

const socket = new Socket();
export default socket;